"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _InfoLabel = _interopRequireDefault(require("../InfoLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var validate = exports.validate = function validate(values) {
  var errors = {};
  var regex = /^http(s){0,1}:\/\/[^.]{1,}\.[^.]{1,}/;
  if (!values.url || values.url === '') {
    errors.url = 'URL is required';
  } else if (!regex.test(values.url)) {
    errors.url = "Must include protocol. E.g., 'https://www.google.com' instead of 'www.google.com'";
  }
  if (values["short"]) {
    if (values["short"].length < 4) {
      errors["short"] = 'Short Code must be at least 4 characters';
    } else if (!/^[a-zA-Z0-9_]+$/.test(values["short"])) {
      errors["short"] = 'Short Code may only contain letters, numbers, and underscores';
    }
  }
  return errors;
};
var CreateForm = function CreateForm(props) {
  var tooltip = 'Add a custom short code for the URL.  It must be at least 4 characters and may only contain letters, numbers, and underscores.';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].registrationForm
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    validate: validate,
    onSubmit: props.handleSubmit,
    initialValues: {
      url: '',
      label: '',
      description: ''
    },
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "url",
        component: _cccisdFormik.CccisdInput,
        label: "URL*"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].infoIcon
      }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        tooltip: tooltip,
        optional: true
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "short",
        component: _cccisdFormik.CccisdInput,
        label: "Short Code"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].optional1
      }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        optional: true
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "label",
        component: _cccisdFormik.CccisdInput,
        label: "Label"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].optional2
      }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        optional: true
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "description",
        component: _cccisdFormik.CccisdTextarea,
        label: "Description"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].submitButton
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Submit")));
    }
  }));
};
CreateForm.propTypes = {
  handleSubmit: _propTypes["default"].func
};
var _default = exports["default"] = CreateForm;